import React, { Component } from 'react';
import * as $ from 'jquery';
import moment from 'moment-timezone';
import spinner from '../../images/loading-spinner.gif';
import { translate } from 'react-i18next';

class InvoiceSearch extends Component {

  componentDidMount() {
    $('#start').datepicker({
      onSelect: (d, i) => {
        if(d !== i.lastVal) {
          this.props.handleStartDate(d);
        }
      }
    });

    $('#end').datepicker({
      onSelect: (d, i) => {
        if(d !== i.lastVal) {
          this.props.handleEndDate(d);
        }
      }
    });
  }

  isSearchEnabled = () => {
    const startDate = this.props.startDate;
    const endDate = this.props.endDate;

    return this.props.remission || (
      startDate
      && endDate
      && moment(startDate, 'MM/DD/YYYY') < moment(endDate, 'MM/DD/YYYY')
    );
  }
  
  render() {
    const { t } = this.props;
    return(
      <div className="jumbotron">
        <form className="form-horizontal" method="post" onSubmit={this.props.handleInvoiceSearch}>
          <fieldset>
            <div className="form-group">
              <label className="col-sm-2 control-label" htmlFor="remission">
                {t('dashboard.invoices.label_remission')}
              </label>
              <div className="col-sm-8">
                <input
                  autoComplete="off"
                  className="form-control"
                  id="remission"
                  onChange={this.props.handleRemissionChange}
                  placeholder={t('dashboard.invoices.holder_remission')}
                  type="text"
                  value={this.props.remission} />
              </div>
              <div className="col-sm-2">
                <div className="hidden-xs">
                  <button
                    className="btn btn-primary"
                    disabled={!this.isSearchEnabled()}
                    type="submit">
                    {t('dashboard.invoices.btn_search')}
                  </button>
                  <img
                    className={this.props.isSearching ? "" : "hidden"}
                    width="45px"
                    height="45px"
                    alt={t('dashboard.reservations.img_spinner')}
                    src={spinner} />
                </div>
              </div>
            </div>
            <div className={this.props.error ? "" : "hidden"}>
              <div className="form-group">
                <div className="col-sm-8 col-sm-offset-2">
                  <div className="alert alert-warning">
                    {this.props.error}
                    <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                  </div>
                </div>
              </div>
            </div>
            <div className="hidden-sm hidden-md hidden-lg">
              <div className="form-group">
                <div className="col-xs-12">
                  <button
                    className="btn btn-primary"
                    disabled={!this.isSearchEnabled()}
                    type="submit">
                    {t('dashboard.invoices.btn_search')}
                  </button>
                  <img
                    className={this.props.isSearching ? "" : "hidden"}
                    width="45px"
                    height="45px"
                    alt={t('dashboard.reservations.img_spinner')}
                    src={spinner} />
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-10 col-sm-offset-2">
                <button
                  className="btn btn-link"
                  data-target="#moreFields"
                  data-toggle="collapse"
                  type="button">
                  {t('dashboard.invoices.btn_more')}&nbsp;
                  <span className="caret" />
                </button>
              </div>
            </div>
            <div className="collapse" id="moreFields">
              <div className="form-group">
                <label className="col-sm-2 control-label" htmlFor="start">
                  {t('dashboard.invoices.label_start')}
                </label>
                <div className="col-sm-8">
                  <input
                    autoComplete="off"
                    className="form-control"
                    id="start"
                    onChange={(e) => this.props.handleStartDate(e.target.value)}
                    placeholder={t('dashboard.invoices.holder_start')}
                    type="text"
                    value={this.props.startDate} />
                </div>
              </div>
              <div className="form-group">
                <label className="col-sm-2 control-label" htmlFor="end">
                  {t('dashboard.invoices.label_end')}
                </label>
                <div className="col-sm-8">
                  <input
                    autoComplete="off"
                    className="form-control"
                    id="end"
                    onChange={(e) => this.props.handleEndDate(e.target.value)}
                    placeholder={t('dashboard.invoices.holder_end')}
                    type="text"
                    value={this.props.endDate} />
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

export default translate('common')(InvoiceSearch);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/InvoiceSearch.js